import React from 'react';
import {
  Box,
  Button,
  Stack,
  SubmitButton,
  TimePicker,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { DatePicker } from '@fortress-technology-solutions/fortress-component-library/Organisms';

import ElementWithPermissions from '../../../ElementWithPermissions';
import {
  validateDateMessage,
  validateDateTime,
} from '../../../../containers/ApplicationProfile/LeaseApplicationTab/ApplicationReceived/validations';
import useIntl from '../../../../hooks/useIntl';
import componentMessages from '../../messages';
import appMessages from '../../../../containers/App/messages';

const messages = {
  ...appMessages,
  ...componentMessages,
};

export default function ApplicationReceivedEditMode({
  toggleEditMode,
  date,
  time,
  dateTime,
  setDate,
  setTime,
  handleSave,
  loading = false,
}) {
  const intl = useIntl();

  return (
    <Box px={2}>
      <Stack gap={1} px={2}>
        <DatePicker
          value={date}
          onChange={setDate}
          error={validateDateMessage(dateTime, intl)}
        />
        <TimePicker
          value={time}
          onChange={setTime}
          error={validateDateTime(dateTime)}
        />
        <Stack
          direction="row"
          justifyContent={'flex-end'}
          alignItems="center"
          gap={1}
        >
          <Button variant="text" onClick={toggleEditMode} size="small">
            {intl.formatMessage(messages.cancel)}
          </Button>
          <ElementWithPermissions scope={['application-received-edit']}>
            <SubmitButton
              variant="primary"
              size="small"
              onClick={handleSave}
              disabled={loading}
              isSubmitting={loading}
            >
              {intl.formatMessage(messages.save)}
            </SubmitButton>
          </ElementWithPermissions>
        </Stack>
      </Stack>
    </Box>
  );
}
